import { useEffect } from 'react';
import {
  NavLink,
  Route,
  BrowserRouter as Router,
  Routes
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setData, useData } from 'wherehouse';
import $ from 'whi18n';
import User from './components/common/User';
import LanguageSwitcher from './components/LanguageSwitcher';
import { useMaxHeight } from './hooks/misc';
import Blog from './projects/blog/components/Blog';
import CopyPasta from './projects/copyPasta';
import CV from './projects/cv/CV';
import Forum from './projects/forum/components/Forum';
import Games from './projects/games/Games';
import Home from './projects/home/Home';
import Labs from './projects/labs/Labs';
import { FULLSCREEN, IS_CV, CV as ViewCV } from './utils/store';

const App = () => {
  useMaxHeight();
  const cv = useData(ViewCV);
  const isCV = useData(IS_CV);
  const fullscreen = useData(FULLSCREEN);
  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    if (search.get('lang')) {
      const lang = search.get('lang');
      window.localStorage.setItem('lang', lang);
      search.delete('lang');
      if (!search.get('redirect')) {
        const url = window.location.href.replace(/lang=[\w-]+&?/g, '').replace(/\?$/g, '');
        window.location.href = url;
      }
    }
    if (search.get('redirect')) {
      let url = `/${search.get('redirect')}`;
      if ([...search.entries()].length > 1) {
        url += `?${[...search.entries()].filter(([key]) => ['redirect', 'lang'].includes(key)).map(e => e.join('=')).join('&')}`;
      }
      window.location.href = url;
    }
  }, []);

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    if (search.get('fullscreen')) {
      setData(FULLSCREEN, true);
    }

    return () => setData(FULLSCREEN, false);
  }, [window.location]);


  // const onClickDownloadAsPDF = useCallback(() => {
  // 	html2canvas(document.querySelector('.CV'), {
  // 		windowWidth: 3508,
  // 		windowHeight: 2480
  // 	}).then(function (canvas) {
  // 		var a = document.createElement('a');
  // 		// toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
  // 		a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
  // 		a.download = 'CV_HAOWU.jpg';
  // 		a.click();
  // 		a.remove();
  // 	});
  // }, []);

  return (
    <Router>
      <div className="App">
        {!fullscreen &&
          <nav>
            <div className="nav">
              <NavLink to="/" end className="logo pc-only"></NavLink>
              <div className="nav-links">
                <NavLink to="/" end title={$`home`}><i className="icon-home"></i></NavLink>
                <NavLink to="/blog" title={$`blog`}><i className="icon-pencil"></i></NavLink>
                <NavLink to="/forum" title={$`forum`}><i className="icon-forum"></i></NavLink>
                <NavLink to="/labs" title={$`labs`}><i className="icon-lab"></i></NavLink>
                <NavLink to="/copy-pasta" title={$`copy-pasta`}><i className="icon-paste"></i></NavLink>
                {cv && <NavLink to="/cv" title={$`cv`}><i className="icon-profile"></i></NavLink>}
                {/* <NavLink to="/games" title={$`games`}><i className="icon-pacman"></i></NavLink> */}
              </div>
              {/* {isCV && <a target="_blank" href="/data/CV_HAOWU.pdf" download><i className="icon-arrow-down" style={{fontSize: '2rem'}}></i><span style={{marginLeft: '0.5rem'}} className="pc-only">{$`download`}</span></a>} */}
              {/* {isCV && <Button onClick={onClickDownloadAsPDF}>{$`download`}</Button>} */}
              <LanguageSwitcher />
              <User />
            </div>
          </nav>
        }
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog/*" element={<Blog />} />
            <Route path="/forum/*" element={<Forum />} />
            <Route path="/labs/*" element={<Labs />} />
            <Route path="/games/*" element={<Games />} />
            <Route path="/cv" element={<CV />} />
            <Route path="/copy-pasta" element={<CopyPasta />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        {!fullscreen &&
          <footer>
            &copy;&nbsp;<a href="https://github.com/wheatup/" target="_blank" rel="noopener noreferrer">wheatup</a>&nbsp;<a target="_blank" href="https://github.com/wheatup/wheatup.github.io/blob/master/LICENSE">@{new Date().getFullYear()} {$`all-rights-reserved`}</a>
          </footer>
        }
        <ToastContainer hideProgressBar closeOnClick autoClose={3000} />
      </div>
    </Router>
  );
}

export default App;
